var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNavUnselectedLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.8 1.8",
    style: {
      enableBackground: "new 0 0 33.8 1.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;}\n\t.st1{fill:#33B0CE;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_24_18_6_",
    transform: "translate(68 184)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_2433-2_11_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-34.7-182.6h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-34.4-182.6-34.7-182.6z  M-37.7-182.6h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-37.5-182.6-37.7-182.6z M-40.8-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-40.5-182.6-40.8-182.6z M-43.8-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-43.5-182.6-43.8-182.6z M-46.8-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-46.5-182.6-46.8-182.6z M-49.9-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-49.6-182.6-49.9-182.6z M-52.9-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-52.6-182.6-52.9-182.6z M-55.9-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-55.6-182.6-55.9-182.6z M-58.9-182.6h-1 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-58.7-182.6-58.9-182.6z M-62-182.6h-1c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S-61.7-182.6-62-182.6z M-65-182.6h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1 c0.3,0,0.5,0.2,0.5,0.5S-64.7-182.6-65-182.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNavUnselectedLine);
export default __webpack_public_path__ + "static/media/q_nav_unselected_line.376064d5.svg";
export { ForwardRef as ReactComponent };